module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/dryShampoo@3x_f90ea6.png";